<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <!-- <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group margin-0">
          <label class="col-sm-2 control-label"> Name</label>
          <div class="col-sm-4">
            <div>
              <el-input placeholder="Event Name" v-model="searchName" name="search"></el-input>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <button class="btn btn btn-primary" @click="search">{{ $t("message.Search") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom: 60px">
              <div class="col-xs-12">{{ total }}{{ $t("message.datagridresult") }}</div>
              <el-table :data="rows" style="width: 100%" border ref="multipleTable" @selection-change="handleSelectionChange" @sort-change="sortChange" @row-dblclick="handleDbClick">
                <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                <el-table-column prop="orderBy" label="Order" min-width="50"></el-table-column>
                <el-table-column prop="categoryCode" label="Membership category" min-width="100" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="membershipName" label="Membership name " min-width="200" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="remark" label="Remark" min-width="120"></el-table-column>
                <el-table-column label="Action " width="100">
                  <template slot-scope="scope">
                    <el-row>
                      <el-col style="text-align: center">
                        <el-button size="mini" @click="handleDbClick(scope.row)" icon="el-icon-edit"></el-button>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination
                  layout="total, sizes, prev, pager, next, jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pagesize"
                  :current-page="page + 1"
                  :total="total"
                  style="float: right"
                >
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {},
  data() {
    return {
      page: 0, //当前页数
      pagesize: 10, //一页显示几条
      filter: "",
      searchName: "",
      internetContentCode: "",
      searchStatus: null,
      total: 0,
      rows: [],
      multipleSelection: [],
      sortType: "DESC",
      sortField: "orderBy",
      selectEventTypeDlg: false,
      setCRMRuleDlg: false,
      eventTypes: "",
      crmEventGroupCode: "",
      status: "",
      eventTypeObj: [],
      statusObj: [],
      dataSourceObj: [],
      categoryList: [],
      rate: "",
      startDate: "",
      endDate: "",
      dataSource: "",
    };
  },
  created: function () {
    if (this.$route.query.sortField) {
      this.sortField = this.$route.query.sortField;
    }
    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page);
    }
    if (this.$route.query.pagesize) {
      this.pagesize = parseInt(this.$route.query.pagesize);
    }
  },
  methods: {
    async init() {
      let objdata = this.getAuthObj();
      objdata.sortField = this.sortField;
      objdata.sortType = this.sortType;
      objdata.startRow = this.page;
      objdata.maxRows = this.pagesize;
      objdata.keyword = this.searchName;
      objdata.membershipCategoryId = this.membershipCategoryId;
      objdata.apiUrl = "/getMembershipList";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      //   let list = null;
      //   for (var i = 0; i < data.data.resultList.length; i++) {
      //     for (var j = 0; j < data.data.resultList[i].langMap.length; j++) {
      //       if (data.data.resultList[i].langMap[j].langCode == "en_US") {
      //         data.data.resultList[i]["title" + "en_US"] = data.data.resultList[i].langMap[j].title;
      //       }
      //       if (data.data.resultList[i].langMap[j].langCode == "zh_HK") {
      //         data.data.resultList[i]["title" + "zh_HK"] = data.data.resultList[i].langMap[j].title;
      //       }
      //       if (data.data.resultList[i].langMap[j].langCode == "zh_CN") {
      //         data.data.resultList[i]["title" + "zh_CN"] = data.data.resultList[i].langMap[j].title;
      //       }
      //     }
      //   }
      objdata.apiUrl = "/getMembershipCategoryList";
      var data2 = await this.$store.dispatch("apiEvent", objdata);
      if (!data2) return;
      this.$set(this, "categoryList", data2.data);
      data.data.resultList.forEach(element => {
        this.categoryList.forEach(item => {
          if (element.membershipCategoryId == item.id) {
            element.categoryCode = item.categoryCode;
            element.categoryType = item.categoryType;
          }
        });
        if (element.langMap.length > 0) {
          element.membershipName = element.langMap[0].membershipName;
        }
      });
      this.rows = data.data.resultList;
      this.setObj();
      this.total = data.data.totalRows;
    },
    async search() {
      this.page = 0;
      this.init();
    },
    showWarning() {
      var that = this;
      if (this.multipleSelection.length != 0) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.deleteList();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {},
            },
          ],
        });
      }
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids;

      objdata.apiUrl = "/deleteEvent";
      var data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) return;
      if (data.data.errorCode === 0) {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    handleSizeChange: function (val) {
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange: function (val) {
      this.page = val - 1;
      this.init();
    },
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/memberPrivilegeDetail",
        query: {
          id: row.id,
          sortField: this.sortField,
          membershipCategoryId: row.membershipCategoryId,
          page: this.page,
          pagesize: this.pagesize,
        },
      });
    },
    sortChange: function (val) {
      if (val.order == "ascending") {
        this.sortType = "ASC";
        this.sortField = val.prop;
      } else if (val.order == "descending") {
        this.sortType = "DESC";
        this.sortField = val.prop;
      } else {
        this.sortType = "ASC";
        this.sortField = "id";
      }
      this.init();
    },
    async setObj() {},
  },
  mounted() {
    this.init();
  },
};
</script>
